<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
              <h3>Add New Purchase Order</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Client:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <ClientAutocomplete :key="companySearchComponentKey" class="searchbox" :list="searchCompany"
                :searchOn="'company_or_registration_no'" @event-name="selectClient"></ClientAutocomplete>
            </div>
            <span class="text-danger text-sm mt-2">{{
              please_choose_client
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>PO Number:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="po_number" v-model="purchaseorders.po_number" v-validate="'required'"
                data-vv-as="PO Number" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('po_number')">{{ errors.first("po_number")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Raised Date:</span>
            </div>
            <div class="vx-col sm:w-1/9">

              <datepicker v-validate="'required'" data-vv-as="Raised Date" :language="$vs.rtl ? langHe : langEn"
                name="raised_date" v-model="purchaseorders.raised_date"></datepicker>
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('raised_date')">{{ errors.first("raised_date")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>PO Status:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">


              <v-select v-validate="'required'" required name="po_status" :options="POStatusList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="purchaseorders.po_status" data-vv-as="PO Status" />


            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('po_status')">{{ errors.first("po_status")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>PO Value:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="total_po_value" v-model="purchaseorders.total_po_value" v-validate="'required'"
                data-vv-as="PO Value" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('total_po_value')">{{ errors.first("total_po_value")
            }}</span>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>PO Allocation:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">

              <v-select disabled v-validate="'required'" required name="po_allocation" :options="POAllocation"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="purchaseorders.po_allocation" data-vv-as="PO Allocation" />

            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('po_allocation')">{{
              errors.first("po_allocation") }}</span>
          </div>



          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm">Submit</vs-button>
            </div>
          </div>

        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import modulePurchaseOrdersManagement from "@/store/campaign-management/purchase-orders-management/modulePurchaseOrdersManagement.js";
import moduleClientsManagement from "@/store/clients-management/moduleClientsManagement.js";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      langHe: he,
      langEn: en,
      POAllocation: ['Not Allocated', 'Partially Allocated', 'Fully Allocated', 'Fully Used'],
      POStatusList: [
        'Confirmed',
        'Invoiced', 'Paid'
      ],
      companySearchComponentKey: 0,
      please_choose_client: null,
      chooseExistingList: false,
      selected_client: null,
      abilities: null,
      purchaseorders: {
        client_id: null,
        po_number: null,
        raised_date: null,
        po_status: null,
        total_po_value: null,
        po_allocation: "Not Allocated",
      },
    };
  },
  components: {
    "v-select": vSelect,
    modulePurchaseOrdersManagement,
    DataGrid,
    Datepicker,
    ClientAutocomplete
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    if (!modulePurchaseOrdersManagement.isRegistered) {
      this.$store.registerModule(
        "PurchaseOrdersManagement",
        modulePurchaseOrdersManagement
      );
      modulePurchaseOrdersManagement.isRegistered = true;
    }


    if (!moduleClientsManagement.isRegistered) {
      self.$store.registerModule("clientsManagement", moduleClientsManagement);
      moduleClientsManagement.isRegistered = true;
    }
  },
  mounted() {
  },
  watch: {

  },
  methods: {
    selectClient() {
      let self = this;
      let clients = moduleClientsManagement.state.clients.datas;
      if (clients) {
        this.selected_client = clients[0];
      }
    },
    searchCompany(inputValue) {
      this.please_choose_client = null;
      return this.$store
        .dispatch("clientsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data = moduleClientsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "PurchaseOrdersManagement/getAllPurchaseOrders",
              params.request
            )
            .then(function (response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.purchaseOrders.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.purchaseOrders.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function () {
      this.$router.go(-1);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.addPurchaseOrders();
        }
      });
    },
    addPurchaseOrders() {
      this.purchaseorders.client_id = this.selected_client.id
      this.$store
        .dispatch("PurchaseOrdersManagement/addPurchaseOrders", this.purchaseorders)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Purchase Order",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Purchase Order Added",
              text: "The purchase order was added successfully"
            });
            this.$router.go(0);
            // this.$router.push({ path: "/client-purchaseorders" });
          }
        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
